"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=chain-type.js.map